import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, text" width="33%" theme="light" className="developerTool" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "207px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "115.94202898550725%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/23c2c34ec2c0aad449660cfed643492b/ee7f6/Developer_Tool_1.webp 207w"],
            "sizes": "(max-width: 207px) 100vw, 207px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/23c2c34ec2c0aad449660cfed643492b/3c09e/Developer_Tool_1.png 207w"],
            "sizes": "(max-width: 207px) 100vw, 207px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/23c2c34ec2c0aad449660cfed643492b/3c09e/Developer_Tool_1.png",
            "alt": "Icon showing a CLI tool being downloaded",
            "title": "Icon showing a CLI tool being downloaded",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Use the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/getting_started/hello-world/"
      }}>{`CLI`}</a>{` to start building with templates. Or, try the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/getting_started/code_playground/"
      }}>{`Code playground`}</a>{` for fast prototyping to experiment without any setup.`}</p>
    <TextBlock slots="image, text" width="33%" theme="light" className="developerTool" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "329px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72.83018867924528%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c9e5037c3a715124759c2194871339c2/dda86/Developer_Tool_2.webp 265w", "/express/add-ons/static/c9e5037c3a715124759c2194871339c2/f80b5/Developer_Tool_2.webp 329w"],
            "sizes": "(max-width: 329px) 100vw, 329px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c9e5037c3a715124759c2194871339c2/28773/Developer_Tool_2.png 265w", "/express/add-ons/static/c9e5037c3a715124759c2194871339c2/9b18f/Developer_Tool_2.png 329w"],
            "sizes": "(max-width: 329px) 100vw, 329px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/c9e5037c3a715124759c2194871339c2/9b18f/Developer_Tool_2.png",
            "alt": "Icon showing Developer Mode being toggled for debugging add-ons",
            "title": "Icon showing Developer Mode being toggled for debugging add-ons",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Test and debug your add-on with `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/getting_started/local_development/browser/"
      }}>{`these developer tools`}</a>{`.`}</p>
    <TextBlock slots="image, text" width="33%" theme="light" className="developerTool" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "309px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "77.73584905660377%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/a8ee16ef178ce15ada84448292751001/dda86/Developer_Tool_3.webp 265w", "/express/add-ons/static/a8ee16ef178ce15ada84448292751001/669b6/Developer_Tool_3.webp 309w"],
            "sizes": "(max-width: 309px) 100vw, 309px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/a8ee16ef178ce15ada84448292751001/28773/Developer_Tool_3.png 265w", "/express/add-ons/static/a8ee16ef178ce15ada84448292751001/e489c/Developer_Tool_3.png 309w"],
            "sizes": "(max-width: 309px) 100vw, 309px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/a8ee16ef178ce15ada84448292751001/e489c/Developer_Tool_3.png",
            "alt": "Icon showing that your add-on can be packaged and shared in the marketplace",
            "title": "Icon showing that your add-on can be packaged and shared in the marketplace",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/build/distribute/"
      }}>{`Package and submit`}</a>{` your add-on to the marketplace.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      